import { DrawerObject } from '../../../../components/drawer/drawer.types';
import { FormBuilderComponent } from '../../../../components/form-builder/form-builder.component';
import { DynamicForm } from '../../../../components/form-builder/form-builder.types';
import { RefTypeRepository } from '../../../../store/ref-type-state/ref-type-state.repository';

interface getRefTypeAddDrawerObjectProps {
  store?: RefTypeRepository;
  formObject?: DynamicForm;
  toggleVisibility?: () => void;
  action?: () => void;
}

export const getRefTypeAddDrawerObject = ({ store, formObject, toggleVisibility, action }: getRefTypeAddDrawerObjectProps): DrawerObject => {
  return {
    title: 'settings.refType.addTitle',
    description: '',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject: formObject,
      },
    },
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'settings.refType.form.submit',
        onClick: () => action?.(),
      },
      {
        label: 'settings.refType.form.cancel',
        onClick: () => {
          toggleVisibility?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
